/* assets/tuinprofiel.js
   Tuinprofiel-test wizard. Vraag 1 bepaalt het licht, vraag 2-5 scoren de bodem
   (hoogste score wint, bij gelijkstand leem). Bij voltooien wordt het resultaat
   naar de Edge Function 'garden-profile' gestuurd (Supabase + Notion). */
(function () {
  'use strict';

  var QUESTIONS = [
    {
      id: 'licht',
      title: 'Hoeveel directe zon krijgt jouw tuin of border op een zomerdag?',
      help: "Hou ook rekening met schaduw van bomen, gebouwen, hagen, pergola's en andere structuren.",
      answers: [
        { text: 'Meer dan 6 uren', light: 'zon' },
        { text: '3 tot 6 uren', light: 'halfschaduw' },
        { text: 'Minder dan 3 uren', light: 'schaduw' }
      ]
    },
    {
      id: 'regen',
      title: 'Wat gebeurt er na een flinke regenbui?',
      answers: [
        { text: 'Het water verdwijnt snel.', soil: 'zand', points: 3 },
        { text: 'Het water trekt geleidelijk weg.', soil: 'leem', points: 3 },
        { text: 'Er blijven lang plassen staan.', soil: 'klei', points: 3 }
      ]
    },
    {
      id: 'droog',
      title: 'Hoe voelt de bodem aan als hij droog is?',
      answers: [
        { text: 'Los en korrelig', soil: 'zand', points: 2 },
        { text: 'Kruimelig en luchtig', soil: 'leem', points: 2 },
        { text: 'Hard en compact', soil: 'klei', points: 2 }
      ]
    },
    {
      id: 'worstje',
      title: 'Neem een handjevol aarde en probeer er een worstje van te kneden. Wat gebeurt er?',
      answers: [
        { text: 'De aarde valt meteen uit elkaar.', soil: 'zand', points: 3 },
        { text: 'Je kan de aarde tot een worstje kneden, maar het valt gemakkelijk uit elkaar.', soil: 'leem', points: 3 },
        { text: 'Je kan de aarde tot een worstje kneden en buigen zonder dat het breekt.', soil: 'klei', points: 3 }
      ]
    },
    {
      id: 'zomer',
      title: 'Wat gebeurt er tijdens een droge zomer?',
      answers: [
        { text: 'De grond voelt nog een hele tijd vochtig.', soil: 'klei', points: 2 },
        { text: 'De grond droogt erg snel uit.', soil: 'zand', points: 2 },
        { text: 'De grond blijft redelijk in balans: niet extreem droog, maar ook niet echt nat.', soil: 'leem', points: 2 }
      ]
    }
  ];

  var LIGHT_LABEL = { zon: 'Zon', halfschaduw: 'Halfschaduw', schaduw: 'Schaduw' };
  var SOIL_LABEL = { zand: 'Zandgrond', leem: 'Leemgrond', klei: 'Kleigrond' };

  // 9 uitkomsten, teksten exact uit de Notion-pagina.
  var RESULTS = {
    'zon-zand': {
      profiel: [
        'Je hebt een zonnige plek met zandgrond die gemakkelijk opwarmt. Dat type bodem droogt snel uit, dus kies planten die goed tegen zon en droogte kunnen.',
        'Veel mediterrane planten voelen zich uitstekend thuis in zulke omstandigheden. Door te werken mét je bodem in plaats van ertegen te vechten, creëer je een onderhoudsvriendelijke tuin die ook tijdens droge periodes mooi blijft.'
      ],
      planten: [
        ['Achillea millefolium', 'Duizendblad'],
        ['Echinacea purpurea', 'Zonnehoed'],
        ['Echinops ritro', 'Kogeldistel'],
        ['Gaura lindheimeri', 'Prachtkaars'],
        ['Nepeta × faassenii', 'Kattenkruid'],
        ['Salvia nemorosa', 'Bossalie']
      ]
    },
    'zon-leem': {
      profiel: [
        'Je hebt een erg veelzijdig tuinprofiel: veel zon en een leembodem die vocht en voeding goed vasthoudt zonder nat te blijven.',
        'Veel tuinliefhebbers dromen van dit type bodem, omdat een enorme waaier aan planten zich thuis voelt daarin. Je hebt dan ook alle vrijheid om verschillende stijlen en beplantingen uit te proberen.'
      ],
      planten: [
        ['Achillea millefolium', 'Duizendblad'],
        ['Aster lateriflorus', 'Herfstaster'],
        ['Echinacea purpurea', 'Zonnehoed'],
        ['Geranium', 'Ooievaarsbek'],
        ['Paeonia lactiflora', 'Pioenroos'],
        ['Salvia nemorosa', 'Bossalie']
      ]
    },
    'zon-klei': {
      profiel: [
        'Je hebt een zonnige plek met een zware, voedselrijke bodem die vocht goed vasthoudt. Kies sterke bloeiers die daarmee overweg kunnen.',
        'Kleigrond heeft soms een slechte reputatie, maar bevat vaak veel voedingsstoffen. Met de juiste planten kan je toch uitbundige borders creëren die net tijdens droge zomers mooi blijven.'
      ],
      planten: [
        ['Aster lateriflorus', 'Herfstaster'],
        ['Eupatorium maculatum', 'Koninginnekruid of leverkruid'],
        ['Geranium', 'Ooievaarsbek'],
        ['Paeonia lactiflora', 'Pioenroos'],
        ['Persicaria amplexicaulis', 'Duizendknoop'],
        ['Veronica longifolia', 'Lange ereprijs']
      ]
    },
    'halfschaduw-zand': {
      profiel: [
        'Je tuin krijgt enkele uren zon per dag, maar je hebt een zandbodem die relatief snel uitdroogt. Kies planten die halfschaduw verdragen en niet te veel vocht nodig hebben.',
        'Deze combinatie komt vaker voor dan je denkt, bijvoorbeeld langs hagen of aan de rand van bomen. Met de juiste planten creëer je een zachte, natuurlijke beplanting die weinig extra zorg vraagt.'
      ],
      planten: [
        ['Aquilegia vulgaris', 'Akelei'],
        ['Astrantia major', 'Zeeuws knoopje'],
        ['Campanula glomerata', 'Klokjesbloem'],
        ['Geranium', 'Ooievaarsbek'],
        ['Heuchera villosa', 'Purperklokje'],
        ['Helleborus orientalis', 'Lenteroos']
      ]
    },
    'halfschaduw-leem': {
      profiel: [
        'Dit is één van de meest veelzijdige tuinprofielen. Je hebt voldoende licht én een leembodem waarin veel vaste planten zich thuis voelen.',
        'Van romantische cottage borders tot strakkere beplantingen: vrijwel alles is mogelijk. Het is dan ook een ideale basis om volop te experimenteren met kleur en bloei.'
      ],
      planten: [
        ['Alchemilla mollis', 'Vrouwenmantel'],
        ['Anemone hybrida', 'Herfstanemoon'],
        ['Astrantia major', 'Zeeuws knoopje'],
        ['Geranium', 'Ooievaarsbek'],
        ['Paeonia lactiflora', 'Pioenroos'],
        ['Salvia nemorosa', 'Bossalie']
      ]
    },
    'halfschaduw-klei': {
      profiel: [
        'Je hebt een plek met gefilterd licht of enkele uren zon en een kleibodem die vocht en voeding goed vasthoudt.',
        'Veel planten waarderen die combinatie omdat ze beschermd zijn tegen de felste middagzon, terwijl de bodem voldoende reserves heeft om droogteperiodes op te vangen.'
      ],
      planten: [
        ['Anemone hybrida', 'Herfstanemoon'],
        ['Astilbe arendsii', 'Pluimspirea'],
        ['Brunnera macrophylla', 'Kaukasisch vergeet-mij-nietje'],
        ['Persicaria amplexicaulis', 'Duizendknoop'],
        ['Thalictrum delavayi', 'Chinese ruit']
      ]
    },
    'schaduw-zand': {
      profiel: [
        'Je hebt een schaduwplek op een zandbodem. Dat is één van de uitdagendere combinaties, maar met sterke, aangepaste planten kan het zeker lukken.',
        'Denk bijvoorbeeld aan plekken onder grote bomen waar de regen nauwelijks de grond bereikt. Kies dan voor planten die zowel schaduw als droogte aankunnen.'
      ],
      planten: [
        ['Epimedium grandiflorum', 'Elfenbloem'],
        ['Geranium', 'Ooievaarsbek'],
        ['Helleborus orientalis', 'Lenteroos'],
        ['Hosta', 'Hartlelie'],
        ['Pulmonaria officinalis', 'Longkruid']
      ]
    },
    'schaduw-leem': {
      profiel: [
        'Je hebt een schaduwrijke plek met een leembodem. Dat type bodem is goed in balans en biedt verrassend veel mogelijkheden voor schaduwplanten.',
        'Een schaduwtuin hoeft zeker niet saai of kleurloos te zijn. Met de juiste planten creëer je een rustige, groene plek vol verschillende bladvormen, texturen en zelfs bloei.'
      ],
      planten: [
        ['Brunnera macrophylla', 'Kaukasisch vergeet-mij-nietje'],
        ['Epimedium grandiflorum', 'Elfenbloem'],
        ['Hosta', 'Hartlelie'],
        ['Pulmonaria officinalis', 'Longkruid'],
        ['Tiarella cordifolia', 'Schuimbloem']
      ]
    },
    'schaduw-klei': {
      profiel: [
        'Je hebt een koele, schaduwrijke plek met een kleibodem die lang vocht kan vasthouden. Veel mensen denken dat je op zo’n grond niet kan tuinieren, maar niets is minder waar.',
        'Er zijn heel wat schaduwplanten die floreren in bosachtige omstandigheden waar de grond vochtiger is. Met de juiste planten creëer je ook daar dus een weelderige en natuurlijke beplanting.'
      ],
      planten: [
        ['Actaea simplex', 'Zilverkaars'],
        ['Astilbe arendsii', 'Pluimspirea'],
        ['Brunnera macrophylla', 'Kaukasisch vergeet-mij-nietje'],
        ['Hosta', 'Hartlelie'],
        ['Rodgersia pinnata', 'Schout-bij-nacht'],
        ['Thalictrum delavayi', 'Chinese ruit']
      ]
    }
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  // Component-CSS (gebruikt de globale theme-tokens uit head.liquid). Wordt één
  // keer geïnjecteerd zodat de widget ook werkt zonder de sectie-<style>,
  // bijvoorbeeld in een Bloggle-embed.
  // Variant A — "Editorial rustig". Heading-font + kleuren komen uit de
  // theme-settings (--FONT-STACK-HEADING, --COLOR-*, --BTN-PRIMARY-BG); de
  // bewust kleinere koptekst-maten zijn vast zodat de modal niet overweldigt.
  var HEAD = 'font-family:var(--FONT-STACK-HEADING);font-weight:var(--FONT-WEIGHT-HEADING);font-style:var(--FONT-STYLE-HEADING);color:var(--COLOR-TEXT)';
  var CSS = [
    '.tp{padding-top:48px;padding-bottom:48px}',
    '.tp--narrow{max-width:820px;margin-left:auto;margin-right:auto}',
    '.tp__head{text-align:center;margin-bottom:1.4rem}',
    '.tp__subheading{text-transform:uppercase;letter-spacing:.14em;font-size:var(--font-body-small);color:var(--BTN-PRIMARY-BG);font-weight:600;margin:0 0 .5rem}',
    '.tp__heading{' + HEAD + ';font-size:30px;line-height:1.15;margin:0}',
    '.tp__panel{border:1px solid var(--COLOR-BORDER);background:var(--COLOR-BG-ACCENT);padding:1.75rem}',
    '.tp__progress{margin-bottom:1.5rem}',
    '.tp__progress-text{font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin:0 0 .4rem}',
    '.tp__progress-track{height:5px;background:var(--COLOR-TEXT-A5);border-radius:999px;overflow:hidden}',
    '.tp__progress-bar{height:100%;width:0;background:var(--BTN-PRIMARY-BG);border-radius:999px;transition:width .3s ease}',
    '.tp__intro-text{margin:0 auto 1.5rem}',
    '.tp__q-title{' + HEAD + ';font-size:21px;line-height:1.3;font-weight:600;margin:0 0 .4rem}',
    '.tp__q-help{color:var(--COLOR-TEXT-LIGHT);font-size:var(--font-body-small);margin:0 0 1.15rem;line-height:1.5}',
    '.tp__options{display:flex;flex-direction:column;gap:.625rem}',
    '.tp__option{display:block;width:100%;text-align:left;padding:.9rem 1.1rem;border:1px solid var(--COLOR-BORDER);border-radius:6px;background:var(--COLOR-BG-BRIGHTER);color:var(--COLOR-TEXT);font-size:var(--font-body);cursor:pointer;transition:border-color .15s,background .15s}',
    '.tp__option:hover{border-color:var(--BTN-PRIMARY-BG)}',
    '.tp__back{margin-top:1.25rem;background:none;border:none;color:var(--COLOR-TEXT-LIGHT);cursor:pointer;font-size:var(--font-body-small);padding:.25rem 0}',
    '.tp__back:hover{color:var(--COLOR-TEXT)}',
    '.tp__result-eyebrow{text-transform:uppercase;letter-spacing:.14em;font-size:var(--font-body-small);color:var(--BTN-PRIMARY-BG);font-weight:600;margin:0 0 .4rem}',
    '.tp__result-title{' + HEAD + ';font-size:26px;line-height:1.2;margin:0 0 1rem}',
    '.tp__result-text{margin:0 0 1rem;line-height:1.55}',
    '.tp__planten-title{' + HEAD + ';font-size:19px;margin:1.5rem 0 .75rem}',
    '.tp__planten{list-style:none;margin:0 0 1.5rem;padding:0;columns:2;column-gap:1.5rem}',
    '.tp__planten li{padding:.4rem 0;border-bottom:1px solid var(--COLOR-BORDER-LIGHT);break-inside:avoid}',
    '.tp__disclaimer{font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin:0 0 1.5rem}',
    '.tp__restart{background:none;border:1px solid var(--BTN-PRIMARY-BG);color:var(--BTN-PRIMARY-BG);padding:.7rem 1.4rem;border-radius:6px;cursor:pointer;font-size:var(--font-body)}',
    '.tp__restart:hover{background:var(--BTN-PRIMARY-BG);color:var(--BTN-PRIMARY-TEXT)}',
    // E-mailcapture
    '.tp__capture{border-top:1px solid var(--COLOR-BORDER-LIGHT);margin:1.5rem 0;padding-top:1.5rem}',
    '.tp__capture-title{' + HEAD + ';font-size:18px;margin:0 0 .85rem}',
    '.tp__capture-form{display:flex;flex-direction:column;gap:.7rem}',
    '.tp__email{padding:.8rem 1rem;border:1px solid var(--COLOR-BORDER);border-radius:6px;background:var(--COLOR-BG-BRIGHTER);color:var(--COLOR-TEXT);font-size:var(--font-body);font-family:inherit;width:100%}',
    '.tp__email:focus{outline:none;border-color:var(--BTN-PRIMARY-BG)}',
    '.tp__nl-label{display:flex;align-items:flex-start;gap:.5rem;font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);cursor:pointer;line-height:1.4}',
    '.tp__nl-label input{margin:.15rem 0 0;flex:none}',
    '.tp__send{align-self:flex-start;border-radius:6px;cursor:pointer}',
    '.tp__capture-msg{font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin:0;min-height:1em}',
    '.tp__capture-done{font-size:var(--font-body);color:var(--COLOR-TEXT);margin:0}',
    // Modal
    '.tp-modal{position:fixed;inset:0;z-index:99999;display:none;align-items:flex-start;justify-content:center;padding:5vh 1rem;background:rgba(0,0,0,.55);overflow-y:auto;-webkit-overflow-scrolling:touch}',
    '.tp-modal.is-open{display:flex}',
    '.tp-modal__dialog{position:relative;background:var(--COLOR-BG);color:var(--COLOR-TEXT);max-width:640px;width:100%;border:1px solid var(--COLOR-BORDER);border-radius:8px;padding:2.5rem 2.75rem 2.25rem;box-shadow:0 16px 40px rgba(0,0,0,.18)}',
    '.tp-modal__close{position:absolute;top:.5rem;right:.5rem;width:2.25rem;height:2.25rem;display:flex;align-items:center;justify-content:center;background:none;border:none;font-size:1.6rem;line-height:1;cursor:pointer;color:var(--COLOR-TEXT-LIGHT)}',
    '.tp-modal__close:hover{color:var(--COLOR-TEXT)}',
    '.tp-modal .tp{padding:0;max-width:none;margin:0}',
    '.tp-modal .tp__panel{border:none;background:transparent;padding:0}',
    '@media (max-width:600px){.tp__planten{columns:1}.tp-modal{padding:0}.tp-modal__dialog{padding:2rem 1.25rem;min-height:100%;border-radius:0}.tp__heading{font-size:25px}.tp__q-title{font-size:19px}}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('tp-styles')) return;
    var st = document.createElement('style');
    st.id = 'tp-styles';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function initWidget(root) {
    var endpoint = root.dataset.endpoint || '';
    var anonKey = root.dataset.key || '';
    // E-mail: in een theme-sectie via Liquid (data-email); in een Bloggle-embed
    // (geen Liquid) als fallback via window.__tpCustomerEmail uit theme.liquid.
    var email = root.dataset.email || window.__tpCustomerEmail || '';
    var loggedIn = root.dataset.loggedIn === 'true' || !!email;
    var source = root.dataset.source === 'blog' ? 'blog' : 'page';

    var stageEl = root.querySelector('.tp__stage');
    var progressBar = root.querySelector('.tp__progress-bar');
    var progressText = root.querySelector('.tp__progress-text');

    var state = { step: 0, light: null, scores: { zand: 0, leem: 0, klei: 0 } };

    function updateProgress() {
      var total = QUESTIONS.length;
      var done = Math.min(state.step, total);
      if (progressBar) progressBar.style.width = (done / total * 100) + '%';
      if (progressText) progressText.textContent = 'Vraag ' + Math.min(state.step + 1, total) + ' van ' + total;
    }

    function computeSoil() {
      var s = state.scores;
      // Hoogste score bepaalt de bodem; bij een gelijke hoogste score wint leem.
      var max = Math.max(s.zand, s.leem, s.klei);
      var leaders = [];
      if (s.zand === max) leaders.push('zand');
      if (s.leem === max) leaders.push('leem');
      if (s.klei === max) leaders.push('klei');
      return leaders.length === 1 ? leaders[0] : 'leem';
    }

    function renderQuestion() {
      var q = QUESTIONS[state.step];
      updateProgress();
      var html = '<div class="tp__question">';
      html += '<h3 class="tp__q-title">' + esc(q.title) + '</h3>';
      if (q.help) html += '<p class="tp__q-help">' + esc(q.help) + '</p>';
      html += '<div class="tp__options">';
      q.answers.forEach(function (a, i) {
        html += '<button type="button" class="tp__option" data-index="' + i + '">' +
          '<span class="tp__option-text">' + esc(a.text) + '</span></button>';
      });
      html += '</div>';
      if (state.step > 0) {
        html += '<button type="button" class="tp__back">← Vorige vraag</button>';
      }
      html += '</div>';
      stageEl.innerHTML = html;

      stageEl.querySelectorAll('.tp__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          choose(q, parseInt(btn.dataset.index, 10));
        });
      });
      var back = stageEl.querySelector('.tp__back');
      if (back) back.addEventListener('click', goBack);
    }

    function choose(q, idx) {
      var a = q.answers[idx];
      if (q.id === 'licht') {
        state.light = a.light;
      } else if (a.soil) {
        state.scores[a.soil] += a.points;
      }
      state.step += 1;
      if (state.step >= QUESTIONS.length) {
        finish();
      } else {
        renderQuestion();
      }
    }

    function goBack() {
      if (state.step === 0) return;
      state.step -= 1;
      var q = QUESTIONS[state.step];
      // Reset het effect van de vraag waar we naar terugkeren.
      if (q.id === 'licht') {
        state.light = null;
      } else {
        // Herbereken bodemscores vanaf nul tot aan deze stap (veiligst).
        state.scores = { zand: 0, leem: 0, klei: 0 };
      }
      renderQuestion();
    }

    function finish() {
      var light = state.light;
      var soil = computeSoil();
      var key = light + '-' + soil;
      var data = RESULTS[key];
      renderResult(light, soil, data);
      submit(light, soil);
    }

    function renderResult(light, soil, data) {
      updateProgress();
      if (progressBar) progressBar.style.width = '100%';
      if (progressText) progressText.textContent = 'Jouw resultaat';

      var html = '<div class="tp__result">';
      html += '<p class="tp__result-eyebrow">Jouw tuinprofiel</p>';
      html += '<h3 class="tp__result-title">' + esc(LIGHT_LABEL[light]) + ' + ' + esc(SOIL_LABEL[soil].toLowerCase()) + '</h3>';
      (data.profiel || []).forEach(function (p) {
        html += '<p class="tp__result-text">' + esc(p) + '</p>';
      });
      html += '<h4 class="tp__planten-title">Deze planten passen in jouw tuin of border</h4>';
      html += '<ul class="tp__planten">';
      (data.planten || []).forEach(function (pl) {
        html += '<li><em>' + esc(pl[0]) + '</em> – ' + esc(pl[1]) + '</li>';
      });
      html += '</ul>';
      html += '<p class="tp__disclaimer">Deze test geeft een goede eerste indicatie van jouw tuinprofiel. Geen enkele tuin laat zich perfect in een vakje stoppen, maar de resultaten helpen je wel om betere plantenkeuzes te maken.</p>';

      // E-mailcapture: resultaat naar de mailbox + optionele nieuwsbrief-opt-in.
      html += '<div class="tp__capture">';
      html += '<h4 class="tp__capture-title">Stuur dit resultaat naar je mailbox</h4>';
      html += '<form class="tp__capture-form" novalidate>';
      html += '<input type="email" class="tp__email" placeholder="jouw@email.be" autocomplete="email" value="' + esc(email) + '" aria-label="E-mailadres" required>';
      html += '<label class="tp__nl-label"><input type="checkbox" class="tp__nl"> Ja, hou me op de hoogte van nieuws en tuintips van Angelo.</label>';
      html += '<button type="submit" class="tp__send btn btn--primary btn--solid">Stuur mij het resultaat</button>';
      html += '<p class="tp__capture-msg" role="status" aria-live="polite"></p>';
      html += '</form></div>';

      html += '<button type="button" class="tp__restart">Test opnieuw doen</button>';
      html += '</div>';
      stageEl.innerHTML = html;

      var restart = stageEl.querySelector('.tp__restart');
      if (restart) restart.addEventListener('click', function () {
        state = { step: 0, light: null, scores: { zand: 0, leem: 0, klei: 0 } };
        renderQuestion();
      });

      var capForm = stageEl.querySelector('.tp__capture-form');
      if (capForm) capForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = capForm.querySelector('.tp__email');
        var nlEl = capForm.querySelector('.tp__nl');
        var msg = capForm.querySelector('.tp__capture-msg');
        var val = (emailEl.value || '').trim();
        if (!val || val.indexOf('@') < 1) { msg.textContent = 'Vul een geldig e-mailadres in.'; emailEl.focus(); return; }
        var sendBtn = capForm.querySelector('.tp__send');
        sendBtn.disabled = true;
        msg.textContent = 'Versturen…';
        sendToKlaviyo(val, nlEl.checked, light, soil).then(function (ok) {
          if (ok) {
            capForm.innerHTML = '<p class="tp__capture-done">Gelukt! Je tuinprofiel is onderweg naar ' + esc(val) + '.</p>';
          } else {
            sendBtn.disabled = false;
            msg.textContent = 'Er ging iets mis. Probeer het straks opnieuw.';
          }
        });
      });
    }

    function sendToKlaviyo(emailVal, newsletter, light, soil) {
      if (!endpoint) return Promise.resolve(false);
      var data = RESULTS[light + '-' + soil] || {};
      var planten = (data.planten || []).map(function (p) { return { lat: p[0], nl: p[1] }; });
      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + anonKey,
          'apikey': anonKey
        },
        body: JSON.stringify({
          action: 'klaviyo',
          email: emailVal,
          newsletter: !!newsletter,
          light: LIGHT_LABEL[light],
          soil: SOIL_LABEL[soil],
          profile: LIGHT_LABEL[light] + ' + ' + SOIL_LABEL[soil],
          profieltekst: data.profiel || [],
          planten: planten,
          source: source
        })
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }

    function submit(light, soil) {
      if (!endpoint) return;
      var body = {
        light: LIGHT_LABEL[light],
        soil: SOIL_LABEL[soil],
        logged_in: loggedIn,
        source: source,
        scores: state.scores
      };
      if (loggedIn && email) body.email = email;
      try {
        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + anonKey,
            'apikey': anonKey
          },
          body: JSON.stringify(body),
          keepalive: true
        });
      } catch (e) { /* stil falen: resultaat is al getoond */ }
    }

    // (Her)start de wizard vanaf vraag 1. Optioneel met een bron (page/blog),
    // zodat dezelfde modal vanuit een blog of pagina de juiste Bron registreert.
    function start(opts) {
      opts = opts || {};
      if (opts.source) source = opts.source === 'blog' ? 'blog' : 'page';
      state = { step: 0, light: null, scores: { zand: 0, leem: 0, klei: 0 } };
      var intro = root.querySelector('.tp__intro');
      if (intro) intro.hidden = true;
      renderQuestion();
    }

    // Inline gebruik (zonder modal): een eventuele interne startknop bindt op start.
    var startBtn = root.querySelector('.tp__start-btn');
    if (startBtn) {
      startBtn.addEventListener('click', function () { start(); });
    } else {
      renderQuestion();
    }

    return { start: start, root: root };
  }

  // De globale modal (één keer in theme.liquid gerenderd) bevat de test.
  function initModal() {
    var modal = document.querySelector('.tp-modal');
    if (!modal || modal.dataset.tpInit) return;
    modal.dataset.tpInit = '1';
    injectCSS();
    var root = modal.querySelector('.tp[data-endpoint]');
    var widget = root ? initWidget(root) : null;

    function open(source) {
      if (!widget) return;
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      widget.start({ source: source });
      var closeBtn = modal.querySelector('.tp-modal__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    modal.__tpOpen = open;

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.tp-modal__close') ||
          (e.target.closest('[data-tp-close]'))) {
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  // Knoppen met [data-tp-open] openen de globale modal — overal plaatsbaar
  // (theme-sectie, blogpost-HTML, ...). Eén keer gebonden via delegation.
  var triggersBound = false;
  function bindTriggers() {
    if (triggersBound) return;
    triggersBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tp-open]');
      if (!btn) return;
      e.preventDefault();
      var modal = document.querySelector('.tp-modal');
      if (modal && modal.__tpOpen) {
        modal.__tpOpen(btn.getAttribute('data-tp-source') || 'page');
      }
    });
  }

  // Sommige editors (o.a. Bloggle) strippen tekst tussen <button>-tags. Vul een
  // lege trigger daarom met data-tp-label of een standaardtekst.
  function fillEmptyTriggers() {
    document.querySelectorAll('[data-tp-open]').forEach(function (btn) {
      if (!btn.textContent.trim()) {
        btn.textContent = btn.getAttribute('data-tp-label') || 'Start de test';
      }
    });
  }

  function init() {
    initModal();
    bindTriggers();
    fillEmptyTriggers();
    // Terugwaarts compatibel: een losse inline .tp (buiten de modal) blijft werken.
    document.querySelectorAll('.tp[data-endpoint]').forEach(function (root) {
      if (root.closest('.tp-modal') || root.dataset.tpInit) return;
      root.dataset.tpInit = '1';
      injectCSS();
      initWidget(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
